import { BCMSStateManagerCRUD, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, PageContainer, PageContentView } from "components/shared";
import PageTitleView from "components/shared/views/PageTitleView";
import { getDefault, getWorkflowSteps } from "components/workflows/LoginFastBalancesWorkflow";
import { Account } from "model";
import React from "react";
import FastBalanceAccountView from "./components/FastBalancesAccountView";

import Util from "classes/Util";
import "./styles.css";


/**
 * @function LoginFastBalancesPage
 * @return {React.Component}
 * @exported true
 * @description The main component for LoginFastBalancesPage
 * @example
 * <LoginFastBalancesPage />
 */
export default function LoginFastBalancesPage(props) {
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps)
    const navigate = useRoute();
    // Set the data and ui variables with the default values and whats passed
    // through the properties
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    // The state that will be passed to the state manager
    const state = { data, ui };
    // :: React.state, React.setState -> OBJECT
    // Function that returns the controller for the state manager
    const controller = (state, setState) => ({
        data: state.data, // Set the data property in the controller
        ui: state.ui, // Set the ui property in the controller 

        // onChange :: STRING, * -> VOID
        // Update the data based on the passed prop and value parameters
        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", prop ], value)
                .submit(setState);
        }
    });

    // Create an array of fast balance account views.
    const fastBalanceAccountViews = data.accounts.reduce((acc, account) => {
        acc.push(<FastBalanceAccountView key={ account.id } account={ account } />);
        return acc;
    }, []);

    const routeBack = evt => Util.inMabi ? Util.routeMabi("login") : navigate("/login");

    return (
        <PageContainer className="login-fast-balances-page" state={ state } controller={ controller }>
            <PageTitleView title="Fast Balances" leftIcon="LeftChevronIcon" leftIconOnClick={ routeBack } />
            <PageContentView>
                <CenterContentContainer>{ fastBalanceAccountViews }</CenterContentContainer>
            </PageContentView>
        </PageContainer>
    );
}

/**
 * @name getDefaultPageData
 * @returns {OBJECT}
 * @description Hook to return the default data that the pages needs
 */
export const getDefaultPageData = () => {
    // Create an array of fast balance accounts.
    const accounts = Account.initAll().reduce((acc, account) => {
        if(account.hasFastBalance) acc.push(account);
        return acc;
    }, []);

    return {
        accounts
    };
}

/**
 * @name getDefaultPageUI
 * @returns {OBJECT}
 * @description Hook to return the default ui that the page needs
 */
export const getDefaultPageUI = () => ({
    // no capture ui needed for now.
});


